module.exports = __webpack_public_path__ + "static/media/hobby.3e1c8a30.png";